import React from 'react';
import Text from '../text';
import { SIZES, APPEARANCES, TYPES, TARGETS } from './constants';
// @ts-ignore TS(2322): Type 'Function' is not assignable to type '(...arg... Remove this comment to see the full error message
const Link = ({
  href,
  target = TARGETS.blank,
  isUnderlined = false,
  size = SIZES.inherit,
  appearance = APPEARANCES.inherit,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'ValueOf<typeof WEIGHTS> | AnyString'.
  weight = null,
  children,
  onClick = Function.prototype,
}) => {
  const linkConfig = {
    href,
    ...(target !== TARGETS.self && { target }),
  };

  return (
    <Text
      type={TYPES.link}
      linkConfig={linkConfig}
      isUnderlined={isUnderlined}
      size={size}
      appearance={appearance}
      weight={weight}
      onClick={onClick}
    >
      {children}
    </Text>
  );
};

export default Link;
